import React from 'react';
import { PageMissingDefault } from './PageMissingDefault';
import { AccessibilityDefault } from './AccessibilityDefault';
import { HtmlSitemapDefault } from './HtmlSitemapDefault';
import { PrivacyDefault } from './PrivacyDefault';
import { ThankYouDefault } from './ThankYouDefault';

const UtilitySelector = ({ sanity, page, section }) => {
  switch (section?.template) {
    case 'pageMissing':
      return (
        <PageMissingDefault page={page} sanity={sanity} section={section} />
      );
    case 'accessibility':
      return (
        <AccessibilityDefault page={page} sanity={sanity} section={section} />
      );
    case 'htmlSitemap':
      return (
        <HtmlSitemapDefault page={page} sanity={sanity} section={section} />
      );
    case 'privacy':
      return <PrivacyDefault page={page} sanity={sanity} section={section} />;
    case 'thankYou':
      return <ThankYouDefault page={page} sanity={sanity} section={section} />;
    default:
      return null;
  }
};

export { UtilitySelector };
